export const FILTERS = {
  CREATED_DATE: 'createdDate',
  UPDATED_DATE: 'updatedDate',
  HEADING_TYPE: 'headingType',
  REFERENCES: 'references',
  SUBJECT_HEADINGS: 'subjectHeadings',
  AUTHORITY_SOURCE: 'sourceFileId',
  SHARED: 'shared',
};

export const REFERENCES_VALUES_MAP = {
  excludeSeeFrom: 'excludeSeeFrom',
  excludeSeeFromAlso: 'excludeSeeFromAlso',
};
